export const importDelegationsTypes = {
  SET_DELEGEES_DATA: "context/SET_DELEGEES_DATA",
  SET_SELECTED_PARKING_RIGHTS: "context/SET_SELECTED_PARKING_RIGHTS",
  SET_PROCESSING: "context/SET_PROCESSING",
  RESET: "context/RESET",
};
